import React, {useEffect, useState} from "react";
import makeAnimated from "react-select/animated";
import toast from "react-hot-toast";

import plugins from "suneditor/src/plugins";
import {
    Card,
    CardFooter,

} from "@material-tailwind/react";
import {ArrowPathIcon} from "@heroicons/react/24/solid";
import DatePicker from "./DatePicker";
import SendAnalysis from "./SignAnalysis";
import SunEditor from "suneditor-react";
import Mkb10List from "../pages/Mkb10/components/Mkb10List";
import {MagnifyingGlassIcon} from "@heroicons/react/24/outline";
import {sendDateToServer, uploadFiles, uploadRemark} from "../services/visitService";
import {fetchMkb10Data, saveMKB10Data, searchMkb10Data} from "../services/MKB10Service";
import {Icon} from "./PatientDetailTabs";
import customPluginSubmenu from "../config/customPluginSubmenu";
import {postDispensaryData} from "../services/dispansery";
import {
    Switch,
    Upload,
    Button as ButtonAnt,
    Badge,
    Tag,
    Collapse,
    Table,
    message,
    Pagination,
    Spin,
    Radio,
    Tabs,
    Input, Modal, Select, Button
} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import TextEditor from "./TextEditor";
import {fetchTemplates, saveTemplate} from "../services/templateService";
import TreatmentPlan from "./TreatmentPlan";
import axiosInstance from "../axios/axiosInstance";
import DentalChart, {ALL_TEETH, LOWER_ROW, UPPER_ROW, getToothName} from "./dental/DentalChart";
import { useTranslation } from "react-i18next";
const { Panel } = Collapse;
const { TabPane } = Tabs;
const { Option } = Select;
export default function AccordionCustomIcon({ patientId, mkb10, visitId, discount}) {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(0);
    const [alwaysOpen, setAlwaysOpen] = React.useState(true);
    const [selectedDisease, setSelectedDisease] = useState(null);
    const [mkb10Data, setMkb10Data] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedMKB10, setSelectedMKB10] = useState([]);
    const TABLE_HEAD = [t('common.code'), t('visit.colName'), t('common.actions')];
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const animatedComponents = makeAnimated();
    const [searchQuery, setSearchQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isVisitStarted, setIsVisitStarted] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 30,
            total: 0,
        },
    });

    const [editorContent, setEditorContent] = useState('');
    const [templateName, setTemplateName] = useState(""); // New template name
    const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
    const defaultEditorValue =
        `
      <p><strong>UNITY: o'z o'yiningizni qanday qilish kerak? </strong></p><p><br></p><p><strong>Tavsif</strong>:Taqdim etilgan yuqori sifatli darslarda biz sizga zamonaviy kompyuter o'yinini yaratishning barcha bosqichlarini batafsil aytib beramiz; Keling, o'yinlarni yaratish uchun zamonaviy dasturiy ta'minotning interfeysi, asosiy tushunchalari va tushunchalarini ko'rib chiqaylik. Bu qismda biz nima qilamiz:</p><p><br></p><ul><li>Unity ko'rinishini o'rnatish va sozlash;</li><li><br></li><li>Keling, ushbu "dvigatel" ning asosiy tushunchalarini ko'rib chiqaylik: o'yin ob'ekti, aktiv, prefabrik, komponent, sahna va boshqalar;</li><li><br></li><li>virtual uch o'lchamli fazoda o'yin ob'ektlarini joylashtirish va o'zgartirishni o'rganamiz;</li><li><br></li><li>Keling, kamera, yorug'lik manbalari, zarralar nima ekanligini ko'rib chiqaylik;</li><li><br></li><li>Unity Technologies kompaniyasining Asset Store o'yin ob'ektlari do'konini ko'rib chiqing;</li><li><br></li><li>Keling, o'yinimizda fizikadan qanday foydalanishni bilib olaylik.</li></ul><p><br></p><p>Kurs harakatlar ketma-ketligiga bo'linadi, ular orqali muallif Unity yordamida kompyuter o'yinlarini yaratishning ba'zi sirlarini batafsil ochib beradi. Kursning birinchi qismini tugatgandan so'ng, siz sertifikatga qo'shimcha ravishda o'yin sohasida martabangizni oshirish imkonini beradigan amaliy ko'nikmalarga ega bo'lasiz. Unity bugungi kunda ham mustaqil ishlab chiquvchilar, ham yirik studiyalar tomonidan yuqori sifatli kompyuter o'yinlarini yaratish uchun faol foydalanilmoqda.</p><p><br></p><p><strong>Bu kurs kimlar uchun</strong>:</p><ul><li>Kompyuter o'yinlarini rivojlantirishni orzu qiladigan maktab o'quvchilari, talabalar, kattalar</li><li>O'z kasbini dasturlash bilan bog'lamoqchi bo'lganlar</li><li>Kompyuterga ishtiyoqli va yangi bilimlarga tashnalar</li></ul><p><br></p>
  `;

    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleFileChange = ({ fileList }) => {
        setSelectedFiles(fileList);
    };

    const handleUpload = async () => {
        try {
            if (selectedFiles.length === 0) {
                console.error("No files selected");
                return;
            }

            const formData = new FormData();
            selectedFiles.forEach((file, index) => {
                formData.append(`upload[${index}]`, file.originFileObj);
            });

            await uploadFiles(visitId, formData);
            console.log("Files uploaded successfully");
            toast.success(t('visit.filesSent'));
        } catch (error) {
            console.error("Error uploading files:", error);
            toast.error(t('visit.filesError'));
        }
    };

    useEffect(() => {
        const loadTemplates = async () => {
            try {
                const templatesData = await fetchTemplates();
                setTemplates(templatesData);

                if (templatesData.length > 0) {
                    setSelectedTemplate(templatesData[0].name);
                    setEditorContent(templatesData[0].html);
                }

                setLoading(false);
            } catch (error) {
                console.error('Ошибка при загрузке шаблонов:', error);
                setLoading(false);
            }
        };

        loadTemplates();
    }, []);

    const handleTemplateChange = (templateName) => {
        setSelectedTemplate(templateName);

        const selected = templates.find((template) => template.name === templateName);

        // Проверяем, найден ли шаблон и устанавливаем контент
        if (selected && selected.html) {
            setEditorContent(selected.html); // Устанавливаем контент шаблона в редактор
        } else {
            setEditorContent(''); // Сбрасываем содержимое, если шаблон не найден
        }
    };

    const handleSubmit = async () => {
        try {
            const formData = new FormData();
            formData.append('text', editorContent);

            const result = await uploadRemark(visitId, formData);
            message.success(t('visit.commentSent'));
            console.log(result);
        } catch (error) {
            message.error(t('visit.commentError'));
            console.error('Ошибка:', error);
        }
    };

    const handleSubmitTemplate = async () => {
        try {
            await saveTemplate(templateName, editorContent);
            message.success(t('visit.templateSent'));
            const updatedTemplates = await fetchTemplates();
            setTemplates(updatedTemplates);
            setTemplateName('');
            setEditorContent('');
            setIsTemplateModalVisible(false);
        } catch (error) {
            message.error(t('visit.templateError'));
            console.error('Ошибка:', error);
        }
    };





    useEffect(() => {
        const status = localStorage.getItem("visitStatus");
        setIsVisitStarted(status === "started");
    }, []);

    useEffect(() => {
        fetchData();
    }, [tableParams.pagination.current]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const { formattedData, meta } = await fetchMkb10Data(tableParams.pagination.current);

            const initialSelectedMKB10 = mkb10.map(item => item.id);
            const selectedData = formattedData.filter(item => initialSelectedMKB10.includes(item.id));
            const remainingData = formattedData.filter(item => !initialSelectedMKB10.includes(item.id));

            const combinedData = [...selectedData, ...remainingData];
            setData(combinedData);
            setFilteredData(combinedData);
            setSelectedMKB10(initialSelectedMKB10);

            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: meta.total,
                },
            });
        } catch (error) {
            console.error('Error fetching data:', error);
            message.error('Failed to load data');
        }
        setLoading(false);
    };

    const handleTableChange = (pagination) => {
        setTableParams({
            pagination,
        });
    };

    const handleOpen = () => {
        setOpen(open);
    };

    const handleSwitchChange = (id, checked) => {
        setSelectedMKB10(prevState => {
            const updatedMKB10 = checked
                ? [...prevState, id]
                : prevState.filter(item => item !== id);
            return updatedMKB10;
        });
    };

    const handleSelectChange = selectedOptions => {
        setSelectedDisease(selectedOptions);
    };

    const handleSaveMKB10 = async () => {
        try {
            // Передаем идентификатор пациента и выбранные MKB-10 коды
            await saveMKB10Data(patientId, selectedMKB10);
            toast.success(t('visit.mkbAdded'));
        } catch (error) {
            console.error("Error sending MKB-10 data:", error);
        }
    };

    const sendDateData = async () => {
        if (!selectedDate) {
            toast.error(t('visit.pickDate'));
            return;
        }

        const payload = { date_at: selectedDate };

        try {
            await sendDateToServer(visitId, payload);
            toast.success(t('visit.revisitSet', { date: selectedDate }));
        } catch (error) {
            console.error("Error sending date data:", error);
        }
    };

    const sendDateDespansery = async (patientId) => {

        const payload = {
            mouth_days: [selectedDate],
            patient_id: patientId,
            visit_id: visitId,
            service_id: 1,
        };

        try {
            await postDispensaryData(payload);
            console.log('sen!!!')
            toast.success(t('visit.dispensarySet', { date: selectedDate }));
        } catch (error) {
            console.error("Error sending date data:", error);
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const responseData = await searchMkb10Data(searchQuery);
            setData(responseData);
        } catch (error) {
            console.error('Error fetching MKB-10 data:', error);
            message.error('Failed to search data');
        }
        setLoading(false);
    };

    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        if (query) {
            const lowerCaseQuery = query.toLowerCase();
            const filtered = data.filter(item =>
                item.code.toLowerCase().includes(lowerCaseQuery) ||
                item.name.toLowerCase().includes(lowerCaseQuery)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(data);
        }
    };



    plugins.custom_plugin_submenu = customPluginSubmenu(setTemplates);

    const editorOptions = {
        plugins: plugins,
        buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['paragraphStyle', 'blockquote'],
            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
            ['fontColor', 'hiliteColor', 'textStyle'],
            ['removeFormat'],
            '/',
            ['outdent', 'indent'],
            ['align', 'horizontalRule', 'list', 'lineHeight'],
            ['table', 'link', 'image', 'video'],
            ['fullScreen', 'showBlocks', 'codeView'],
            ['preview', 'print'],
            ['custom_plugin_submenu'],
            ['template'],
            ['save'],
        ],
        templates: templates,
    };


    const columns = [
        {
            title: t('common.code'),
            dataIndex: 'code',
            sorter: true,
            width: '20%',
        },
        {
            title: t('visit.colName'),
            dataIndex: 'name',
            width: '50%',
        },
        {
            title: t('common.actions'),
            dataIndex: 'id',
            render: (id) => (
                <Switch
                    checked={selectedMKB10.includes(id)}
                    onChange={(checked) => handleSwitchChange(id, checked)}
                />
            ),
        },
    ];

    const jawAreas = [
        { id: 1, name: t('dental.jawUpper') },
        { id: 2, name: t('dental.jawLower') },
        { id: 3, name: t('dental.jawLeft') },
        { id: 4, name: t('dental.jawRight') }
    ];

    const orthodonticIssues = [
        { id: 1, issue: t('dental.malocclusion') },
        { id: 2, issue: t('dental.crossbite') },
        { id: 3, issue: t('dental.diastema') },
        { id: 4, issue: t('dental.crowding') },
        { id: 5, issue: t('dental.malposition') }
    ];


    const getToothNameById = (toothId) => getToothName(toothId);


    const [selectedTeeth, setSelectedTeeth] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [teethRemarks, setTeethRemarks] = useState({});

    const [selectedOption, setSelectedOption] = useState("none");

    const handleToothClick = (toothId) => {
        setSelectedTeeth((prev) =>
            prev.includes(toothId) ? prev.filter((id) => id !== toothId) : [...prev, toothId]
        );
    };

    const handleRemarkChange = (toothId, remark) => {
        setTeethRemarks((prev) => ({ ...prev, [toothId]: remark }));
    };


    const handleSelectionChange = (e) => {
        setSelectedOption(e.target.value);
        if (e.target.value === "upper") {
            setSelectedTeeth([...UPPER_ROW]);
        } else if (e.target.value === "lower") {
            setSelectedTeeth([...LOWER_ROW]);
        } else if (e.target.value === "all") {
            setSelectedTeeth([...ALL_TEETH]);
        } else {
            setSelectedTeeth([]);
        }
    };


    const handleTeethSubmit = () => {
        const data = new FormData();

        selectedTeeth.forEach((toothId, index) => {
            data.append(`teeth[${index}]`, toothId);
            data.append(`remark[${index}]`, teethRemarks[toothId] || "");
        });


        for (let pair of data.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        axiosInstance.post(`/visit/teethes/${visitId}`, data)
            .then(response => {
                console.log('Teeth data submitted successfully:', response.data);
                toast.success(t('dental.teethSaved'))
            })
            .catch(error => {
                console.error('Error submitting teeth data:', error);
            });
    };

    return (
        <>

            <div >
                <Tabs  tabPosition="left" defaultActiveKey="1">

                    <TabPane tab={t('visit.conclusion')} key="1">
                        <div className="flex flex-col gap-3 mb-2">
                            <Upload.Dragger
                                beforeUpload={() => false}
                                fileList={selectedFiles}
                                multiple={true}
                                onChange={handleFileChange}
                                style={{border: '1px dashed #d9d9d9', borderRadius: '4px', padding: '16px'}}
                            >
                                <p className="ant-upload-drag-icon">
                                    <DownloadOutlined/>
                                </p>
                                <p className="ant-upload-text">{t('visit.dragFiles')}</p>
                                <p className="ant-upload-hint">
                                    {t('visit.clickFiles')}
                                </p>
                            </Upload.Dragger>
                            <ButtonAnt className="shadow-none text-sm rounded-sm" size="large" type="primary"
                                       onClick={handleUpload}>{t('visit.saveSend')}</ButtonAnt>
                        </div>
                        {loading ? (
                            <Spin tip={t('visit.loadingTemplates')}/>
                        ) : (
                            <>
                                <h3>{t('visit.pickTemplate')}:</h3>
                                <div className="flex items-center gap-4">
                                    <Select
                                        onChange={handleTemplateChange}
                                        value={selectedTemplate}
                                        style={{width: '100%'}}
                                        placeholder={t('visit.pickTemplate')}
                                    >
                                        {templates.map((template) => (
                                            <Option key={template.name} value={template.name}>
                                                {template.name}
                                            </Option>
                                        ))}
                                    </Select>
                                    <ButtonAnt
                                        className="shadow-none" block type="primary"
                                        onClick={() => setIsTemplateModalVisible(true)}>
                                        {t('visit.addTemplate')}
                                    </ButtonAnt>
                                </div>

                                {/* Modal for Adding a Template */}
                                <Modal
                                    title={t('visit.addTemplate')}
                                    visible={isTemplateModalVisible}
                                    onCancel={() => setIsTemplateModalVisible(false)}
                                    footer={null}
                                >
                                    <Input
                                        placeholder={t('visit.templateName')}
                                        value={templateName}
                                        onChange={(e) => setTemplateName(e.target.value)}
                                    />
                                    <div className="my-4">
                                        <SunEditor
                                            setOptions={{
                                                buttonList: [
                                                    ['undo', 'redo'],
                                                    ['font', 'fontSize', 'formatBlock'],
                                                    ['bold', 'underline', 'italic'],
                                                    ['fontColor', 'hiliteColor', 'indent', 'outdent'],
                                                    ['align', 'list', 'table'],
                                                    ['link', 'image', 'video'],
                                                    ['fullScreen', 'showBlocks', 'codeView'],
                                                ],
                                            }}
                                            height="300px"
                                            setContents={editorContent}
                                            setDefaultStyle="font-family: Arial; font-size: 16px;"
                                            onChange={setEditorContent}
                                        />
                                    </div>
                                    <ButtonAnt
                                        block
                                        size="large"
                                        type="primary"
                                        onClick={handleSubmitTemplate}
                                        className="mt-4 text-sm"
                                    >
                                        {t('visit.sendTemplate')}
                                    </ButtonAnt>
                                </Modal>

                                <div className="my-4">
                                    <SunEditor
                                        setOptions={{
                                            buttonList: [
                                                ['undo', 'redo'],
                                                ['font', 'fontSize', 'formatBlock'],
                                                ['bold', 'underline', 'italic'],
                                                ['fontColor', 'hiliteColor', 'indent', 'outdent'],
                                                ['align', 'list', 'table'],
                                                ['link', 'image', 'video'],
                                                ['fullScreen', 'showBlocks', 'codeView'],
                                            ],
                                        }}
                                        height="300px"
                                        setContents={editorContent}
                                        setDefaultStyle="font-family: Arial; font-size: 16px;"
                                        onChange={setEditorContent}
                                    />
                                </div>

                                <ButtonAnt block size="large" type="primary" onClick={handleSubmit}
                                           className="mt-4 text-sm">
                                    {t('visit.send')}
                                </ButtonAnt>
                            </>
                        )}
                    </TabPane>
                    <TabPane tab={t('dental.formula')} key="0">
  <div className="flex flex-col xl:flex-row gap-3 xl:gap-5 mb-5">
    {/* Sidebar */}
    <div className="sidebar w-full xl:w-1/4 shrink-0 p-1 bg-[#fafafa] rounded-lg shadow-sm">
      <Tabs type="card" className="w-full px-2 sm:px-4" defaultActiveKey="1">
        <TabPane tab={t('dental.problems')} key="1">
          <div className="problems-list">
            <Input.Search
              placeholder={t('dental.searchProblems')}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ marginBottom: "1rem" }}
            />

            <div className="jaw-areas mb-4">
              <h3>{t('dental.jawAreas')}</h3>
              <Select
                style={{ width: "100%" }}
                showSearch
                placeholder={t('dental.pickJaw')}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {jawAreas.map((area) => (
                  <Option key={area.id} value={area.name}>
                    {area.name}
                  </Option>
                ))}
              </Select>
            </div>

            <div className="orthodontic-issues mt-4">
              <h3>{t('dental.problems')}</h3>
              <Select
                style={{ width: "100%" }}
                showSearch
                placeholder={t('dental.pickProblem')}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {orthodonticIssues.map((issue) => (
                  <Option key={issue.id} value={issue.issue}>
                    {issue.issue}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </TabPane>

        <TabPane tab={t('dental.xrays')} key="2">
          <div className="x-rays">
            <p>{t('dental.noXrays')}</p>
          </div>
        </TabPane>
      </Tabs>
    </div>

    {/* Main Content */}
    <div className="content flex-1 min-w-0">
      <div className="rounded-xl border border-slate-200/90 bg-white overflow-hidden">
        <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2.5 border-b border-slate-100">
          <h3 className="text-sm font-semibold text-slate-800 m-0">{t('dental.formula')}</h3>
          <Radio.Group
            size="small"
            onChange={handleSelectionChange}
            value={selectedOption}
          >
            <Radio.Button value="upper">{t('dental.upper')}</Radio.Button>
            <Radio.Button value="lower">{t('dental.lower')}</Radio.Button>
            <Radio.Button value="all">{t('dental.all')}</Radio.Button>
            <Radio.Button value="none">{t('dental.clear')}</Radio.Button>
          </Radio.Group>
        </div>

        <div className="px-4 py-4">
          <DentalChart
            selected={selectedTeeth}
            remarks={teethRemarks}
            onToggle={handleToothClick}
          />
        </div>

        {selectedTeeth.length > 0 && (
          <div className="px-4 pb-4">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">
              {t('dental.remarksTitle')}
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
              {selectedTeeth.map((toothId) => (
                <div
                  key={toothId}
                  className="flex items-start gap-2 rounded-lg border border-slate-200 p-2"
                >
                  <span
                    className="shrink-0 inline-flex items-center justify-center min-w-[30px] h-7 px-1.5 rounded-md text-xs font-bold text-white tabular-nums"
                    style={{ backgroundColor: '#1D2C7B' }}
                  >
                    {toothId}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-[11px] text-slate-500 mb-1 truncate">
                      {getToothNameById(toothId)}
                    </p>
                    <Input.TextArea
                      rows={1}
                      autoSize={{ minRows: 1, maxRows: 3 }}
                      value={teethRemarks[toothId] || ""}
                      onChange={(e) => handleRemarkChange(toothId, e.target.value)}
                      placeholder={t('dental.remarkPh')}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="px-4 py-3 border-t border-slate-100 bg-slate-50/60 flex justify-end">
          <Button type="primary" onClick={handleTeethSubmit}>
            {t('dental.save')}
          </Button>
        </div>
      </div>
    </div>
  </div>
</TabPane>

                    <TabPane tab={t('visit.revisit')} key="2">
                        <div className="flex gap-4 items-center">
                            <DatePicker onChange={(date) => setSelectedDate(date)}/>
                            <ButtonAnt type="primary" className="flex items-center"
                                       icon={<ArrowPathIcon className='w-4 h-4'/>} onClick={sendDateData}>
                                {t('visit.addRevisit')}
                            </ButtonAnt>
                        </div>
                    </TabPane>

                    <TabPane tab={t('visit.procedure')} key="3">
                        {/*<SendAnalysis open={open} visitId={visitId} />*/}
                        {/*<div className="flex gap-5 mb-5">*/}
                        {/*    /!* Sidebar *!/*/}
                        {/*    /!*<div className="sidebar w-1/4 p-1 bg-[#fafafa] rounded-lg shadow-sm">*!/*/}
                        {/*    /!*    <Tabs type="card" className="w-full px-4" defaultActiveKey="1">*!/*/}
                        {/*    /!*        <TabPane tab={t('dental.problems')} key="1">*!/*/}
                        {/*    /!*            <div className="problems-list">*!/*/}
                        {/*    /!*                <Input.Search*!/*/}
                        {/*    /!*                    placeholder={t('dental.searchProblems')}*!/*/}
                        {/*    /!*                    onChange={(e) => setSearchTerm(e.target.value)}*!/*/}
                        {/*    /!*                    style={{marginBottom: '1rem'}}*!/*/}
                        {/*    /!*                />*!/*/}

                        {/*    /!*                <div className="jaw-areas mb-4">*!/*/}
                        {/*    /!*                    <h3>{t('dental.jawAreas')}</h3>*!/*/}
                        {/*    /!*                    <Select*!/*/}
                        {/*    /!*                        style={{width: '100%'}}*!/*/}
                        {/*    /!*                        showSearch*!/*/}
                        {/*    /!*                        placeholder={t('dental.pickJaw')}*!/*/}
                        {/*    /!*                        optionFilterProp="children"*!/*/}
                        {/*    /!*                        filterOption={(input, option) =>*!/*/}
                        {/*    /!*                            option.children.toLowerCase().includes(input.toLowerCase())*!/*/}
                        {/*    /!*                        }*!/*/}
                        {/*    /!*                    >*!/*/}
                        {/*    /!*                        {jawAreas.map((area) => (*!/*/}
                        {/*    /!*                            <Option key={area.id} value={area.name}>*!/*/}
                        {/*    /!*                                {area.name}*!/*/}
                        {/*    /!*                            </Option>*!/*/}
                        {/*    /!*                        ))}*!/*/}
                        {/*    /!*                    </Select>*!/*/}
                        {/*    /!*                </div>*!/*/}

                        {/*    /!*                <div className="orthodontic-issues mt-4">*!/*/}
                        {/*    /!*                    <h3>{t('dental.problems')}</h3>*!/*/}
                        {/*    /!*                    <Select*!/*/}
                        {/*    /!*                        style={{width: '100%'}}*!/*/}
                        {/*    /!*                        showSearch*!/*/}
                        {/*    /!*                        placeholder={t('dental.pickProblem')}*!/*/}
                        {/*    /!*                        optionFilterProp="children"*!/*/}
                        {/*    /!*                        filterOption={(input, option) =>*!/*/}
                        {/*    /!*                            option.children.toLowerCase().includes(input.toLowerCase())*!/*/}
                        {/*    /!*                        }*!/*/}
                        {/*    /!*                    >*!/*/}
                        {/*    /!*                        {orthodonticIssues.map((issue) => (*!/*/}
                        {/*    /!*                            <Option key={issue.id} value={issue.issue}>*!/*/}
                        {/*    /!*                                {issue.issue}*!/*/}
                        {/*    /!*                            </Option>*!/*/}
                        {/*    /!*                        ))}*!/*/}
                        {/*    /!*                    </Select>*!/*/}
                        {/*    /!*                </div>*!/*/}
                        {/*    /!*            </div>*!/*/}
                        {/*    /!*        </TabPane>*!/*/}

                        {/*    /!*        <TabPane tab={t('dental.xrays')} key="2">*!/*/}
                        {/*    /!*            <div className="x-rays">*!/*/}
                        {/*    /!*                <p>{t('dental.noXrays')}</p>*!/*/}
                        {/*    /!*            </div>*!/*/}
                        {/*    /!*        </TabPane>*!/*/}
                        {/*    /!*    </Tabs>*!/*/}

                        {/*    /!*</div>*!/*/}

                        {/*    /!* Main Content *!/*/}
                        {/*    <div className="content flex-1">*/}
                        {/*        <div*/}
                        {/*            className="dental-formula flex flex-col items-center py-5 bg-[#fafafa] rounded-lg shadow-sm">*/}
                        {/*            <div className="selection-controls mb-4">*/}
                        {/*                <Radio.Group onChange={handleSelectionChange} value={selectedOption}>*/}
                        {/*                    <Radio.Button value="upper">Верхняя полость</Radio.Button>*/}
                        {/*                    <Radio.Button value="lower">Нижняя полость</Radio.Button>*/}
                        {/*                    <Radio.Button value="all">Вся полость</Radio.Button>*/}
                        {/*                    <Radio.Button value="none">Отмена</Radio.Button>*/}
                        {/*                </Radio.Group>*/}
                        {/*            </div>*/}

                        {/*            <div className="teeth-container">*/}
                        {/*                <div className="teeth-top flex items-center justify-center mb-4">*/}
                        {/*                    {teethData.map(({id, margin, name}) => (*/}
                        {/*                        <Tooltip title={name} key={id}>*/}
                        {/*                            <img*/}
                        {/*                                className={`tooth h-20 mx-1 ${selectedTeeth.includes(id) ? 'checked' : ''}`}*/}
                        {/*                                src={`/teeth/${id}.png`}*/}
                        {/*                                onClick={() => handleToothClick(id)}*/}
                        {/*                                style={{margin}}*/}
                        {/*                                alt={name}*/}
                        {/*                            />*/}
                        {/*                        </Tooltip>*/}
                        {/*                    ))}*/}
                        {/*                </div>*/}
                        {/*                <div className="teeth-bottom flex items-center justify-center">*/}
                        {/*                    {bottomTeethData.map(({id, margin, name}) => (*/}
                        {/*                        <Tooltip title={name} key={id}>*/}
                        {/*                            <img*/}
                        {/*                                className={`tooth h-20 mx-1 ${selectedTeeth.includes(id) ? 'checked' : ''}`}*/}
                        {/*                                src={`/teeth/${id}.png`}*/}
                        {/*                                onClick={() => handleToothClick(id)}*/}
                        {/*                                style={{margin}}*/}
                        {/*                                alt={name}*/}
                        {/*                            />*/}
                        {/*                        </Tooltip>*/}
                        {/*                    ))}*/}
                        {/*                </div>*/}
                        {/*            </div>*/}

                        {/*            /!* Selection Controls *!/*/}


                        {/*            {selectedTeeth.length > 0 && (*/}
                        {/*                <div className="remarks-section mt-8 w-full px-6 py-4 bg-gray-50 rounded-lg">*/}
                        {/*                    <h3 className="text-lg font-semibold text-gray-800 mb-4">Даволаш режаси ва диагностика</h3>*/}
                        {/*                    {selectedTeeth.map((toothId) => (*/}
                        {/*                        <div*/}
                        {/*                            key={toothId}*/}
                        {/*                            className="remark-item mb-4 p-4 border w-full border-gray-200 rounded-lg hover:bg-gray-100 transition duration-200 ease-in-out"*/}
                        {/*                        >*/}
                        {/*                            <div className="flex w-full items-center space-x-4">*/}
                        {/*                                /!* Tooth Image *!/*/}
                        {/*                                <img*/}
                        {/*                                    src={`/teeth/${toothId}.png`} // Replace with correct image path or URL*/}
                        {/*                                    alt={`Зуб ${toothId}`}*/}
                        {/*                                    className="w-12 h-12 object-contain"*/}
                        {/*                                />*/}
                        {/*                                /!* Tooth Information *!/*/}
                        {/*                                <div className="w-full">*/}
                        {/*                                    <p className="text-sm font-medium text-gray-700 mb-2">*/}
                        {/*                                        Зуб <span className="font-semibold">{getToothNameById(toothId)}</span> ({toothId}):*/}
                        {/*                                    </p>*/}
                        {/*                                    <Input.TextArea*/}
                        {/*                                        rows={2}*/}
                        {/*                                        value={teethRemarks[toothId] || ""}*/}
                        {/*                                        onChange={(e) => handleRemarkChange(toothId, e.target.value)}*/}
                        {/*                                        placeholder="Диагнозни киритинг"*/}
                        {/*                                        className="w-full text-sm border border-gray-300 rounded-lg p-2"*/}
                        {/*                                    />*/}
                        {/*                                </div>*/}
                        {/*                            </div>*/}
                        {/*                        </div>*/}
                        {/*                    ))}*/}
                        {/*                </div>*/}
                        {/*            )}*/}


                        {/*            /!* Submit Button *!/*/}
                        {/*            <Button  type="primary" size="large" className=" mt-5 w-[600px] text-sm shadow-none" onClick={handleTeethSubmit}>*/}
                        {/*                Отправить*/}
                        {/*            </Button>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <TreatmentPlan discount={discount} open={open} visitId={visitId}/>
                    </TabPane>

                    <TabPane tab={t('admissions.dispensary')} key="4">
                        <div className="flex gap-4 items-center">
                            <DatePicker onChange={(date) => setSelectedDate(date)}/>
                            <ButtonAnt type="primary" className='flex items-center gap-x-1'
                                       onClick={() => sendDateDespansery(patientId)}>
                                <ArrowPathIcon className='w-4 h-4'/>
                                {t('visit.addDispensary')}
                            </ButtonAnt>
                        </div>
                    </TabPane>

                    <TabPane tab={t('mkb10.title')} key="5">
                        <div className="px-5">
                            <label
                                className="relative bg-white min-w-sm flex flex-col md:flex-row items-center justify-center border py-2 px-2 rounded-md gap-2 focus-within:border-gray-300"
                                htmlFor="search-bar">
                                <Mkb10List/>
                                <input
                                    id="search-bar"
                                    placeholder={t('common.search')}
                                    className="px-8 py-1 w-full rounded-md flex-1 outline-none bg-white"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                                <ButtonAnt onClick={handleSearch} size="md">
                                    <MagnifyingGlassIcon className="h-5 w-5"/>
                                </ButtonAnt>
                                <ButtonAnt className='rounded-md' onClick={handleSaveMKB10}>{t('common.save')}</ButtonAnt>
                            </label>
                            <Card className="h-[40vh] shadow-none border w-full rounded-none mt-5 overflow-scroll">
                                <Table
                                    columns={columns}
                                    rowKey={(record) => record.id}
                                    dataSource={filteredData}
                                    loading={loading}
                                    onChange={handleTableChange}
                                />
                            </Card>

                            <CardFooter>
                                <Pagination
                                    {...tableParams.pagination}
                                    onChange={(page, pageSize) => {
                                        setTableParams({
                                            pagination: {current: page, pageSize, total: tableParams.pagination.total},
                                        });
                                    }}
                                />
                            </CardFooter>
                        </div>
                    </TabPane>
                </Tabs>
            </div>


        </>
    );
}